(function () {
  'use strict';

  function hasMeaningfulContent(element) {
    return Array.from(element.childNodes).some(function (node) {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim().length > 0;
      }

      if (node.nodeType === Node.ELEMENT_NODE) {
        return (
          node.tagName.toLowerCase() !== 'br' ||
          node.nextSibling !== null
        );
      }

      return false;
    });
  }

  function initializeProductDescriptions(root) {
    const scope = root || document;

    const descriptions = scope.querySelectorAll(
      '.ProductMeta__Description.ProductDescriptionCollapsible'
    );

    descriptions.forEach(function (description, descriptionIndex) {
      if (description.dataset.descriptionAccordionInitialized === 'true') {
        return;
      }

      const richText = description.querySelector(
        '.ProductDescriptionCollapsible__Content .Rte'
      );

      if (!richText) {
        return;
      }

      const headings = Array.from(
        richText.querySelectorAll(':scope > h2')
      );

      description.dataset.descriptionAccordionInitialized = 'true';

      if (!headings.length) {
        return;
      }

      const accordion = document.createElement('div');
      accordion.className = 'product-description-accordion';

      headings.forEach(function (heading, headingIndex) {
        const item = document.createElement('div');
        item.className =
          'product-description-item Collapsible';

        const button = document.createElement('button');
        button.type = 'button';
        button.className =
          'product-description-toggle Collapsible__Button';
        button.setAttribute('data-action', 'toggle-collapsible');
        button.setAttribute('aria-expanded', 'false');

        const title = document.createElement('span');
       title.className = 'ProductDescriptionCollapsible__Label';
        title.innerHTML = heading.innerHTML;

        const icon = document.createElement('span');
        icon.className = 'Collapsible__Plus';
        icon.setAttribute('aria-hidden', 'true');

        const inner = document.createElement('div');
        inner.className =
          'product-description-panel Collapsible__Inner';

        const content = document.createElement('div');
        content.className =
          'product-description-section-content Collapsible__Content';

        const uniquePrefix =
          description.id ||
          `product-description-${descriptionIndex + 1}`;

        const buttonId =
          heading.id ||
          `${uniquePrefix}-heading-${headingIndex + 1}`;

        const panelId =
          `${uniquePrefix}-panel-${headingIndex + 1}`;

        button.id = buttonId;
        button.setAttribute('aria-controls', panelId);

        inner.id = panelId;
        inner.setAttribute('role', 'region');
        inner.setAttribute('aria-labelledby', buttonId);

        button.appendChild(title);
        button.appendChild(icon);

        let nextNode = heading.nextSibling;

        while (nextNode) {
          const nextSibling = nextNode.nextSibling;

          if (
            nextNode.nodeType === Node.ELEMENT_NODE &&
            nextNode.tagName.toLowerCase() === 'h2'
          ) {
            break;
          }

          if (
            nextNode.nodeType === Node.TEXT_NODE &&
            !nextNode.textContent.trim()
          ) {
            nextNode.remove();
          } else {
            content.appendChild(nextNode);
          }

          nextNode = nextSibling;
        }

        heading.remove();

        inner.appendChild(content);
        item.appendChild(button);
        item.appendChild(inner);
        accordion.appendChild(item);
      });

      /*
       * Place heading accordions outside the main Details accordion.
       */
      description.insertAdjacentElement('afterend', accordion);

      /*
       * Hide Details when the product description contains only H2 sections
       * and no introductory content.
       */
      if (!hasMeaningfulContent(richText)) {
        description.hidden = true;
      }
    });
  }

  function initializePage() {
    initializeProductDescriptions(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePage
    );
  } else {
    initializePage();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeProductDescriptions(event.target);
    }
  );
})();